import { AlertCircle, RotateCw } from 'lucide-react';

/** 会話末尾の user 発言に応答が届かないまま打ち切り時間を過ぎたときの案内 (AiMenuChatPage/ProfileBuilderChatPage 共通) */
export function ResponseMissingNotice({ onResend }: { onResend: () => void }) {
  return (
    <div role="alert" className="p-3 rounded-md bg-danger-bg text-danger-text text-[13px] border border-danger-border flex items-start gap-2">
      <AlertCircle size={16} className="shrink-0 mt-0.5" aria-hidden />
      <div className="min-w-0 space-y-2">
        <p>AIからの応答が届きませんでした。お手数ですが、もう一度送信してください。</p>
        <button
          type="button"
          onClick={onResend}
          className="inline-flex items-center gap-1.5 min-h-[44px] px-3 rounded border border-danger-border bg-white text-sm font-medium"
        >
          <RotateCw size={14} aria-hidden /> もう一度送信する
        </button>
      </div>
    </div>
  );
}
